import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { userIdSelector } from '../selectors';
import { IUserInChatListSchema } from '../types/userData';
import { formatCompanionData } from '../utils/formatCompanionData';
import { getChatListItemCompanion } from '../utils/getChatListItemCompanion';

export const useChatListItemCompanion = (chatUsers: IUserInChatListSchema[]) => {
  const userId = useSelector(userIdSelector);

  const companion = useMemo(() => getChatListItemCompanion(chatUsers, userId), [chatUsers, userId]);

  return useMemo(() => formatCompanionData(companion ?? ({} as IUserInChatListSchema)), [companion]);
};
